// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountGroup } from './account-group';
import { AssetClass } from './asset-class';
import { CurrencyType } from './currency-type';
import { Lookup } from './lookup';
import { ShareholderClass } from './shareholder-class';
import { TaxCode } from './tax-code';
import { Template } from './template';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountTemplate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountId!: number;
  accountCode?: string;
  accountGroupId!: number;
  accountUid!: string;
  assetClassId?: number;
  balance!: number;
  bankId?: number;
  createdBy!: string;
  createdDate!: Date;
  creditorClaimTypeId?: number;
  currencyTypeId!: number;
  description!: string;
  entryCount!: number;
  flags?: number;
  isCore!: boolean;
  isDefault?: boolean;
  isInactive!: boolean;
  isPickable!: boolean;
  lastChqNo?: number;
  lockedDate?: Date;
  longDescription?: string;
  lookupId1?: number;
  lookupId2?: number;
  lookupId3?: number;
  parentAccountAccountId?: number;
  shareholderClassId?: number;
  taxCodeId?: number;
  templateId!: number;
  trustAdminId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountGroup!: AccountGroup;
  assetClass!: AssetClass;
  currencyType!: CurrencyType;
  inverseParentAccountAccount!: AccountTemplate[];
  lookupId1Navigation!: Lookup;
  lookupId2Navigation!: Lookup;
  lookupId3Navigation!: Lookup;
  parentAccountAccount!: AccountTemplate;
  shareholderClass!: ShareholderClass;
  taxCode!: TaxCode;
  template!: Template;
}

